const KEY = 'sopper:wishlist:v1';
const root = window.Shopify?.routes?.root || '/';
const valid = item => item && typeof item.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(item.handle) && /^\d+$/.test(String(item.id));
function read() {
  const value = JSON.parse(localStorage.getItem(KEY) || '[]');
  if (!Array.isArray(value)) return [];
  const seen = new Set();
  return value.filter(item => valid(item) && !seen.has(String(item.id)) && seen.add(String(item.id))).slice(0,200);
}
function write(items) { localStorage.setItem(KEY, JSON.stringify(items)); document.dispatchEvent(new Event('sopper:wishlist')); }
function status(message, target) {
  let region = target?.querySelector('[data-wishlist-status]') || document.getElementById('sopper-wishlist-status');
  if (!region) { region = document.createElement('p'); region.id = 'sopper-wishlist-status'; region.setAttribute('role', 'status'); region.className = 'visually-hidden'; document.body.append(region); }
  region.textContent = message;
}
function sync() {
  let saved = [];
  try { saved = read(); } catch { /* A user action reports disabled or invalid storage. */ }
  document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
    const exists = saved.some(item => String(item.id) === button.dataset.productId);
    button.hidden = false;
    button.setAttribute('aria-pressed', String(exists));
    button.setAttribute('aria-label', `${exists ? button.dataset.removeLabel : button.dataset.saveLabel}: ${button.dataset.productTitle}`);
  });
  document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = String(saved.length); el.hidden = !saved.length; });
}
let loadController;
async function render() {
  const page = document.querySelector('[data-wishlist-page]'); if (!page) return;
  loadController?.abort(); loadController = new AbortController(); const {signal} = loadController;
  const list = page.querySelector('[data-wishlist-items]');
  let items;
  try { items = read(); } catch { status(page.dataset.storageError, page); return; }
  list.replaceChildren();
  status(items.length ? page.dataset.loading : page.dataset.empty, page);
  // Limit concurrent public product reads; token-free and localized.
  const queue = [...items];
  const entries = new Map(items.map(item => { const li = document.createElement('li'); li.className = 'sopper-wishlist__item'; list.append(li); return [item.id,li]; }));
  async function worker() {
    while (queue.length && !signal.aborted) {
      const item = queue.shift(); const li = entries.get(item.id);
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(item.handle)}.js`, {signal});
        if (response.status === 404) { const p = document.createElement('p'); p.textContent = page.dataset.unavailable; li.append(p); }
        else {
          if (!response.ok) throw new Error('Product request failed');
          const product = await response.json();
          // Never substitute another product if an old handle has been reused.
          if (String(product.id) !== String(item.id)) throw new Error('Product changed');
          const a = document.createElement('a'); a.href = `${root}products/${encodeURIComponent(product.handle)}`;
          if (product.featured_image) {
            const img = document.createElement('img'); img.src = product.featured_image; img.alt = ''; img.width = 320; img.height = 320; img.loading = 'lazy'; a.append(img);
          }
          const title = document.createElement('span'); title.textContent = product.title; a.append(title); li.append(a);
          if (!product.available) { const p = document.createElement('p'); p.textContent = page.dataset.unavailable; li.append(p); }
        }
      } catch {
        if (signal.aborted) return;
        const p = document.createElement('p'); p.textContent = page.dataset.error; li.append(p);
        const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = page.dataset.retry; retry.addEventListener('click', render); li.append(retry);
      }
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = page.dataset.remove;
      remove.addEventListener('click', () => {
        try {
          const remaining = read().filter(entry => String(entry.id) !== String(item.id));
          const focusTarget = li.nextElementSibling || li.previousElementSibling;
          write(remaining); li.remove(); status(remaining.length ? '' : page.dataset.empty, page);
          if (focusTarget) focusTarget.querySelector('a,button')?.focus();
          else { page.querySelector('h1').tabIndex = -1; page.querySelector('h1').focus(); }
        } catch { status(page.dataset.storageError,page); }
      });
      li.append(remove);
    }
  }
  await Promise.all([worker(),worker(),worker(),worker()]);
  if (!signal.aborted) status(items.length ? '' : page.dataset.empty,page);
}
document.addEventListener('click', event => {
  const button = event.target.closest('[data-wishlist-toggle]'); if (!button) return;
  event.preventDefault(); event.stopPropagation();
  try {
    const items = read(); const id = button.dataset.productId;
    const exists = items.some(item => String(item.id) === id);
    if (!valid({id,handle:button.dataset.productHandle})) return;
    write(exists ? items.filter(item => String(item.id) !== id) : [...items,{id,handle:button.dataset.productHandle}]);
    status(exists ? button.dataset.removeLabel : button.dataset.saveLabel);
  } catch { status(button.dataset.storageError); }
}, true);
document.addEventListener('sopper:wishlist', sync);
window.addEventListener('storage', event => { if (event.key === KEY) { sync(); render(); } });
window.addEventListener('pageshow', sync);
document.addEventListener('shopify:section:load', () => {sync(); render();});
let syncQueued = false;
const observer = new MutationObserver(records => {
  if (syncQueued || !records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[data-wishlist-toggle]') || n.querySelector?.('[data-wishlist-toggle]'))))) return;
  syncQueued = true; queueMicrotask(() => { syncQueued = false; sync(); });
});
observer.observe(document.body, {childList: true, subtree: true});
sync(); render();
